var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "icon-container",
      style: [
        _vm.styles,
        { width: `${_vm.width}px`, height: `${_vm.height}px` },
      ],
    },
    [
      _c("div", {
        staticClass: "icon-svg",
        domProps: { innerHTML: _vm._s(_vm.svgContent) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }